import "../../assets/scss/global.scss";
import logo from "../../assets/img/logo.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";

import userIcon from "../../assets/img/user_icon_sm.svg";
import logoutIcon from "../../assets/img/logout_icon.svg";
import { useDispatch } from "react-redux";
import { logoutAction } from "../../redux/action";
// import { ADMINPROMPTPAGE, ADMINPROMPTSADD, ADMINPROMPTSEDIT, ADMINSUPPORTPAGE, ADMINSUBSCRIPTIONPAGE, ADMINUSERCLINICIANSPAGE, ADMINCMSTESTIMONIALPAGE,  } from "../../util/path";
import { ADMINPROMPTPAGE, ADMINPROMPTSADD, ADMINPROMPTSEDIT, ADMINSUPPORTPAGE, ADMINSUBSCRIPTIONPAGE, ADMINUSERCLINICIANSPAGE, ADMINCMSTESTIMONIALPAGE, ADMINCMS, ADMINCMSFAQSPAGE, ADMINCMSABOUTPAGE, ADMINCMSSERVICEPAGE, ADMINCMSPRIVACYPAGE, ADMINCMSTERMSPAGE, ADMINCONTACTUSPAGE, ADMINTEMPLATEPAGE, ADMINTEMPLATESADD, ADMINSOCIALMEDIAPAGE } from "../../util/path";

const AdminHeader = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [isSticky, setIsSticky] = useState(false);

  const [menuBar, setMenubar] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const isTokenAvailable = localStorage.getItem("accessToken");
    setIsLoggedIn(true);

    // if (isTokenAvailable) {
    //   setIsLoggedIn(true);
    // } else {
    //   setIsLoggedIn(false);
    // }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const top = window.scrollY;
      if (top > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this effect runs once when the component mounts

  const login = () => {
    navigate("/login");
  };

  const disptach = useDispatch();

  const logout = () => {
    localStorage.clear();
    navigate("/");
    disptach(logoutAction());
  };

  const home = () => {
    navigate("/admin/prompts");
  };

  return (
    <>
      <header className={`site_header ${isSticky ? "sticky_header" : ""}`}>
        <div className="site_container">
          <div className="site_navbar">
            <div className="site_brand">
              <a onClick={() => home()}>
                <img src={logo} alt="" />
              </a>
            </div>
            <div className={menuBar ? "site_menus menu_show" : "site_menus"}>
              <ul className="site_menu_bar">
                <li
                  className={
                    location.pathname === ADMINPROMPTPAGE || location.pathname === ADMINPROMPTSADD || location.pathname.startsWith('/admin/prompts/view/') ? "active_page" : ""
                  }
                >
                  <Link to={`${ADMINPROMPTPAGE}`}>Prompts</Link>
                </li>{" "}
                <li
                  className={
                    location.pathname === ADMINTEMPLATEPAGE || location.pathname === ADMINTEMPLATESADD || location.pathname.startsWith('/admin/template/view/') ? "active_page" : ""
                  }
                >
                  <Link to={`${ADMINTEMPLATEPAGE}`}>Template</Link>
                </li>{" "}
                <li
                  className={
                    location.pathname === ADMINSUPPORTPAGE || location.pathname === ADMINSUPPORTPAGE ? "active_page" : ""
                  }
                >
                  <Link to={`${ADMINSUPPORTPAGE}`}>Suport request</Link>
                </li>{" "}

                <li
                  className={
                    location.pathname === ADMINUSERCLINICIANSPAGE || location.pathname === ADMINUSERCLINICIANSPAGE ? "active_page" : ""
                  }
                >
                  <Link to={`${ADMINUSERCLINICIANSPAGE}`}>Users</Link>
                </li>{" "}
                <li
                  className={
                    location.pathname === ADMINSUBSCRIPTIONPAGE || location.pathname === ADMINSUBSCRIPTIONPAGE || location.pathname.startsWith('/admin/subscription/view/') ? "active_page" : ""
                  }
                >
                  <Link to={`${ADMINSUBSCRIPTIONPAGE}`}>Subscription</Link>
                </li>{" "}

                <li
                  className={`has-submenu ${location.pathname.startsWith(ADMINCMS) ? "active_page" : ""}`}
                >
                  <Link>Cms</Link>
                  <ul className="submenu">
                    <li>
                      <Link
                        to={`${ADMINCMSTESTIMONIALPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSTESTIMONIALPAGE}` ? "active" : ""}`}
                      >
                        Testimonial
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${ADMINCMSFAQSPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSFAQSPAGE}` ? "active" : ""}`}
                      >
                        FAQS
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINCMSABOUTPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSABOUTPAGE}` ? "active" : ""}`}
                      >
                        About Us
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINCMSSERVICEPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSSERVICEPAGE}` ? "active" : ""}`}
                      >
                        Services
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINCMSPRIVACYPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSPRIVACYPAGE}` ? "active" : ""}`}
                      >
                        Privacy Policy
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINCMSTERMSPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCMSTERMSPAGE}` ? "active" : ""}`}
                      >
                        Terms & Condition
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINCONTACTUSPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINCONTACTUSPAGE}` ? "active" : ""}`}
                      >
                        Contact Us
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`${ADMINSOCIALMEDIAPAGE}`}
                        className={`submenu-link ${location.pathname === `${ADMINSOCIALMEDIAPAGE}` ? "active" : ""}`}
                      >
                        Social Media
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>

              {isLoggedIn ? (
                <>
                  <div className="user_panel">
                    <div className="avatar" style={{ cursor: "pointer" }}>
                      <span>AB</span>
                    </div>
                    <div className="user_drop">
                      <ul>
                        <li><Link to={'/change-password'}><img src={userIcon} alt="" /> 
                          <span>Change Password</span></Link>
                        </li>
                        <li>
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={() => logout()}
                          >
                            <img src={logoutIcon} alt="" /> <span>Logout</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="login_btns">
                    <Link to={"/signup"} className="solid_cta cta_white">
                      {" "}
                      Sign up
                    </Link>
                    <Link to={"/login"} className="solid_cta cta_primary">
                      {" "}
                      Login
                    </Link>
                  </div>
                </>
              )}
            </div>
            <span
              className={menuBar ? "menu_toggler toggled" : "menu_toggler"}
              onClick={() => setMenubar(!menuBar)}
            >
              <span></span>
            </span>
          </div>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
